import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

/**
 * Deep link from workspace "New course" → full creation flow scoped to that workspace.
 */
export default function CreateCoursePage() {
  const { id: workspaceId } = useParams<{ id: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!workspaceId) {
      navigate("/dashboard", { replace: true });
      return;
    }
    navigate(`/create?workspaceId=${encodeURIComponent(workspaceId)}`, { replace: true });
  }, [workspaceId, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <p className="text-muted-foreground">Opening course creator…</p>
    </div>
  );
}
